import * as Yup from 'yup';
import { messages } from 'app/config/constants';

export const caseBuildingPlotValidationSchema = Yup.object({
  plotBeingFormed: Yup.boolean().notRequired(),
  formationCommitment: Yup.object().when('plotBeingFormed', (keys, schema) =>
    keys[0] ? schema.required(messages.MANDATORY_FIELD) : schema.notRequired()
  ),
  plotRatio: Yup.string().when('plotBeingFormed', (keys, schema) =>
    keys[0] ? schema.required(messages.MANDATORY_FIELD) : schema.notRequired()
  )
});

export const plotBeingCreatedValidationSchema = Yup.object({
  cadastralMunicipality: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  plot: Yup.string().required(messages.MANDATORY_FIELD)
})
